import React, { useState, useEffect } from 'react';

function CustomerEdit({ onCustomerUpdated, customerData, userId }) {
  const [name, setName] = useState(customerData.name);
  const [phone, setPhone] = useState(customerData.phone);
  const [address, setAddress] = useState(customerData.address);
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('https://www.irsaliye.bybello.com/backend/api/customers.php', {
      method: 'PUT', // PUT metodu kullanıldı
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: customerData.id, // Güncellenecek müşterinin ID'si
        name,
        phone,
        address,
        user_id: userId // Güvenlik için user_id'yi de gönderiyoruz
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage('Müşteri başarıyla güncellendi!');
          if (onCustomerUpdated) onCustomerUpdated(); // Güncelleme sonrası tetikleyici
        } else {
          setMessage(data.error || 'Bir hata oluştu.');
        }
      })
      .catch(() => setMessage('Bir hata oluştu.'));
  };

  return (
    <div>
      <h2>Müşteri Düzenle: {customerData.name}</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="nameInput" className="form-label">Ad Soyad</label>
          <input
            id="nameInput"
            type="text"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="phoneInput" className="form-label">Telefon</label>
          <input
            id="phoneInput"
            type="text"
            className="form-control"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="addressInput" className="form-label">Adres</label>
          <input
            id="addressInput"
            type="text"
            className="form-control"
            value={address}
            onChange={e => setAddress(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary">Güncelle</button>
      </form>
      {message && <div className="mt-3">{message}</div>}
    </div>
  );
}

export default CustomerEdit;
